import { Injectable, EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs/Rx';
import * as _ from 'underscore';

@Injectable()
export class ChartsService {
    notifyMe: EventEmitter<any>;

    chartColors = ["#FF6600", "#FCD202", "#B0DE09", "#0D8ECF", "#2A0CD0", "#CD0D74",
        "#CC0000", "#00CC00", "#0000CC", "#DDDDDD", "#999999", "#333333", "#990000"];

    chartbullets = ["round", "square", "triangleUp", "triangleDown", "bubble"];

    constructor() {
        this.notifyMe = new EventEmitter<any>();
    }

    public notifyall() {
        this.notifyMe.emit(null);
    }

    groupBy(data: any[], propertyName: string): any[] {
        return _(data).groupBy(propertyName);
    }

    groupByThenSumOrAvg(data: any[], groupProperty: string, sumProperty: string, avgProperty?: string): any[] {
        var groups = this.groupBy(data, groupProperty);

        let count = 1;

        var out = _(groups).map(function (g, key) {

            if (avgProperty)
                count = this.getCountOfValues(g, avgProperty);

            let avg = Math.round(this.sum(g, sumProperty) / count)

            return {
                [groupProperty]: key,
                [sumProperty]: avg === Infinity ? 0 : avg
            };
        }, this);

        return out;
    }

    groupByThenCount(data: any[], groupProperty: string, countProperty: string): any[] {
        var groups = this.groupBy(data, groupProperty);

        var out = _(groups).map(function (g, key) {
            return {
                [groupProperty]: key,
                Count: this.getCountOfValues(g, countProperty)
            };
        }, this);

        return out;
    }

    sortDatesAsc(data: any[], propertyName: string): any[] {
        return _.sortBy(data, (elem) => {
            let splitedDate = elem[propertyName].split('-');
            return new Date(Number.parseInt(splitedDate[0]), Number.parseInt(splitedDate[1]) - 1, Number.parseInt(splitedDate[2])).getTime();
        });
    }

    sortAsc(data: any[], sortBy: string): any[] {
        return _.sortBy(data, sortBy);
    }

    sortDesc(data: any[], sortBy: string): any[] {
        return this.sortAsc(data, sortBy).reverse();
    }

    sum(data: any[], property: string): number {
        return _(data).reduce(function (sum, obj) { return sum + obj[property]; }, 0)
    }

    // {key: 22/1/2016, Active: 40, Parking: 90}
    groupByThenSumEachValOfProperty(data, groupProperty: string, propertyKeys: string, sum: string, perProperty?: string) {
        let groups = this.groupBy(data, groupProperty);
        let keys = this.getValuesOfProperty(data, propertyKeys);

        let out = _(groups).map(function (g, key) {
            let result = { key: key };
            for (let i = 0; i < keys.length; i++) {
                let s = this.sum(this.filterBy(g, propertyKeys, keys[i]), sum);

                let count = 1;
                if (perProperty)
                    count = this.getCountOfValues(g, perProperty);

                result[keys[i]] = s ? Math.round(s / count) : 0;
            }

            return result;
        }, this);

        return out;
    }

    getValuesOfProperty(data, property) {
        return _.uniq(_.pluck(data, property));
    }

    getCountOfValues(data, property) {
        return _.size(this.getValuesOfProperty(data, property));
    }

    filterBy(data, property: string, value: any) {
        return _.where(data, { [property]: value });
    }

    getCoordinatesGroupedByProperty(data: any[], groupProperty: string, xProperty: string, yProperty: string, pointText: string) {
        let keys = this.getValuesOfProperty(data, groupProperty);
        let groups = this.groupBy(data, groupProperty);
        let out = _(groups).map(function (g, key) {
            let result = [];

            for (let i = 0; i < g.length; i++)
                result.push({
                    key: key,
                    [key + 'x']: g[i][xProperty],
                    [key + 'y']: g[i][yProperty],
                    PointText: g[i][pointText]
                });

            return this.sortAsc(result, key + 'x');
        }, this);


        return _.flatten(out);
    }

    getMaxOfSum(data: any[], propertyKeys: string[], maxCount: number): any[] {
        let keyValue = [];
        for (let i = 0; i < data.length; i++)
            keyValue.push({ key: data[i].key, sum: this.sumProperties(data[i], propertyKeys) });

        keyValue = this.sortDesc(keyValue, 'sum');
        keyValue = keyValue.slice(0, maxCount); // get max top 5

        let newData = [];
        for (let i = 0; i < keyValue.length; i++)
            newData.push(_.first(this.filterBy(data, 'key', keyValue[i].key)));

        return newData;
    }

    sumProperties(obj: any, properties: string[]): number {
        let result = 0;
        for (let i = 0; i < properties.length; i++)
            result += obj[properties[i]];

        return result;
    }

    groupbyThenDivideSumBySum(data: any, groupProperty: string, sumProperty: string, perProperty: string) {
        var groups = this.groupBy(data, groupProperty);

        var out = _(groups).map(function (g, key) {

            let perSum = this.sum(g, perProperty);
            let avg = Math.round(this.sum(g, sumProperty) / perSum);
            return {
                [groupProperty]: key,
                [sumProperty]: avg === Infinity ? 0 : avg
            };
        }, this);

        return out;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/chartService/charts.service.ts